import { render, staticRenderFns } from "./RegistrationContent.vue?vue&type=template&id=7a15e106&scoped=true&"
import script from "./RegistrationContent.vue?vue&type=script&lang=js&"
export * from "./RegistrationContent.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationContent.vue?vue&type=style&index=0&id=7a15e106&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a15e106",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VIcon,VTextField})
